import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";

import "./Table.scss";

const Table = ({
  headlines,
  rows,
  hasActions,
  hasSizeLimitation,
  customStyles,
  className
}) => {
  const lang = useSelector((state) => state.locale.lang);

  return (
    <TableContainer
      component={Paper}
      className={`table-container ${className}`}>
      <MuiTable>
        <TableHead>
          <TableRow>
            {headlines.map(
              (head, i) =>
                head && (
                  <TableCell
                    className={`font-regular fsize-14 text-color ${customStyles} ${
                      hasSizeLimitation ? "w-25" : ""
                    } ${lang === "ar" && "text-end"}`}
                    key={`header-${i}`}>
                    {head}
                  </TableCell>
                )
            )}
            {hasActions && (
              <TableCell
                className={`actions-cell text-gray font-regular fsize-14 ${
                  lang === "ar" && "text-end"
                }`}></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </MuiTable>
    </TableContainer>
  );
};

Table.propTypes = {
  headlines: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.node,
  hasActions: PropTypes.bool,
  hasSizeLimitation: PropTypes.bool,
  className: PropTypes.string,
  customStyles: PropTypes.string
};

Table.defaultProps = {
  headlines: [],
  hasActions: false
};

export default Table;
